export default () => ({
  formGroupPanel: {
    marginBottom: 15,
  },
  formLabel: {
    color: '#232E4E',
    fontSize: '1.4rem',
    marginBottom: 15,
    marginTop: 15,
  },
});



// WEBPACK FOOTER //
// ./src/components/Panels/FormGroupPanel.styles.js